import React, { useEffect, useState } from "react";
import "./page_3.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrophy, faBirthdayCake} from '@fortawesome/fontawesome-free-solid'
//import { config, dom, library } from '@fortawesome/fontawesome-svg-core';
import { faHorse, faHorseHead, faTree ,faMedal } from '@fortawesome/free-solid-svg-icons';
import {Link} from "react-router-dom";
import { useTranslation } from 'react-i18next';

function Page_3(){
    const { t } = useTranslation();
    const [data, setData] = useState(null);

    useEffect(() => {
      fetch('/data.json')
        .then(response => response.json())
        .then(data => setData(data))
        .catch(error => console.error('Error fetching data:', error));
    }, []);
    if (!data) {
        return (<div>Loading...</div>)
      }


    return(

        //import ownerPicture_2 from "../../../data/appData/appImages/owner/owner2.jpg" ;
        <div className="page3_content">
            <div className="float-start w-100 text-center mt-3 fw-bold fs-5">{t("champions")}</div>
            <div className="page3_content_marge page3_content_marge_resp" >

            
                {data.items.map(function(champion ){
                    if( champion.betterPrice !== "" && champion.category === "purSang" && champion.isDisplayed === true){
                    
                        return (
                            <div className="OnChampionDiv">
                                <div className="championPictureDiv "> <img  className="championPicture" src={"/data/appData/appImages/champions/" + champion.id+".jpg"} alt="" onContextMenu={(e)=> e.preventDefault()}/></div>
                                
                                <Container >
                                    <Row>
                                        <Col xs={2} sm={2}  md={2} lg={2}><div className="championAttributLabel fw-bold  text-start"><FontAwesomeIcon icon={faHorse} /> {t("name")}</div></Col>
                                        <Col xs={4} sm={4}  md={4} lg={4}><div className=" text-start">{  champion.name}</div></Col>
                                        <Col xs={2} sm={2}  md={2} lg={2}><div className="championAttributLabel fw-bold text-start"><FontAwesomeIcon icon={faBirthdayCake} /> {t("borne")}</div></Col>
                                        <Col xs={4} sm={4}  md={4} lg={4}><div className="  text-sm-start">{ champion.borne_date }  </div></Col>
                                    </Row>
                                    <Row>
                                        <Col xs={2} sm={2}  md={2} lg={2}><div className="championAttributLabel fw-bold text-start"><FontAwesomeIcon icon={faHorseHead}  /> {t("father")}</div></Col>
                                        <Col xs={4} sm={4}  md={4} lg={4}><div className="  text-start">{champion.father}</div></Col>
                                        <Col xs={2} sm={2}  md={2} lg={2}><div className="championAttributLabel fw-bold text-start"> <FontAwesomeIcon icon={faHorseHead}  /> {t("mother")}</div></Col>
                                        <Col xs={4} sm={4}  md={4} lg={4}><div className="  text-start">{ champion.mother }</div></Col>
                                    </Row>  
                                    <br></br>
                                    <Row>
                                        <Col xs={11}><div className="championAttributLabel margedChampionAttributLabel fw-bold text-start"><FontAwesomeIcon icon={faTrophy}  /> {t("betterPrice")}</div></Col>
                                        <Col xs={1}><div className="  text-start"></div></Col>
                                    </Row>  
                                    <Row>
                                        <Col xs={0} sm={0}  md={2} lg={2}><div className="championAttributLabel fw-bold text-start"></div></Col>
                                        <Col xs={12 } sm={12} md={10} lg={10}><div className="  text-start ">{champion.betterPrice}</div></Col>
                                    </Row>  
                                    <Row>
                                        <Col xs={11}><div className="championAttributLabel margedChampionAttributLabel fw-bold text-start"><FontAwesomeIcon icon={faTrophy}  /> {t("allPrices")}</div></Col>
                                        <Col xs={1}><div className="  text-start"></div></Col>
                                    </Row> 
                                    {champion.prices.map(function(price, index){
                                        return(
                                            <Row key={index}>
                                                <Col xs={0} sm={0}  md={2} lg={2}><div className="championAttributLabel fw-bold text-start"></div></Col>
                                                <Col xs={12 } sm={12} md={10} lg={10} ><div className="  text-start"><FontAwesomeIcon icon={faMedal}  /> {price}</div></Col>
                                            </Row> 
                                        )
                                    }) }
                                    <Link to={`image/${champion.id}/page3`} style={{textDecoration:'none', color:'black'}}> 
                                    <Row>
                                        
                                            <Col xs={12}><div className="championAttributLabel margedChampionAttributLabel fw-bold text-start"><FontAwesomeIcon icon={faTree}  /> <span>Pedigree  +...</span> </div></Col>
                                            
                                        
                                    </Row> 
                                    <Row>
                                    
                                    <Col xs={12}><div> <img width="100%" className="pedigreeImage mb-4 " src={"/data/appData/appImages/pedigree/" + champion.id +".png"} alt={"pedigree " + champion.name} onContextMenu={(e)=> e.preventDefault()} /> </div></Col>

                                    </Row>
                                    </Link>
                                        
                                </Container>
                                
                                
                            
                            </div>
                            
                        )
                    }

                })}
            </div>

        </div>
        

    )

}

export default Page_3